import apiPath from '../../../config/api';

const StockPath = {
    title: "Permata - Saldo Awal",
    basePath: "/permata/stok",
    newPath: "/permata/stok/baru",
    detailPath: "/permata/stok/opsi/:id",
    api: apiPath.retailStock,
    generated: apiPath.retailStockGenerated,
    excel: apiPath.retailStockExcel,
    goods: apiPath.retailStockGoods
}

export default StockPath;
